import { FileShareReportProfileDelegate } from '../../../microsoft/fileshare/profile/file-share-report-profile-delegate';
import { ReportProfileAlertResourceBaseModel } from '../../../profile/report-profile-alert-resource-base-model';

export class FileShareReportProfileAlertDelegateModel extends ReportProfileAlertResourceBaseModel {
  delegate: FileShareReportProfileDelegate;
  allFolders: boolean;
  folders: string[];
}
